import { render, staticRenderFns } from "./d-user-info-popup.vue?vue&type=template&id=35d71422&scoped=true&"
import script from "./d-user-info-popup.vue?vue&type=script&lang=js&"
export * from "./d-user-info-popup.vue?vue&type=script&lang=js&"
import style0 from "./d-user-info-popup.vue?vue&type=style&index=0&id=35d71422&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d71422",
  null
  
)

export default component.exports